

// Get siblings
const getSiblings = n => [...n.parentNode.children].filter(c => c.nodeType == 1 && c != n);
// ============================



// let's get this party started
document.addEventListener('DOMContentLoaded', function () {


  var swiper = new Swiper(".js_swiper_v", {
    direction: "vertical",
    allowTouchMove: false,
    navigation: {
      nextEl: '.js_swiper_v_next',
      prevEl: '.js_swiper_v_prev',
    },
  });


  var swiper2 = new Swiper(".js_swiper_h", {
    resistanceRatio: 0,
    navigation: {
      nextEl: '.js_swiper_h_next',
      prevEl: '.js_swiper_h_prev',
    },
  });

  document.querySelectorAll('.js_swiper_v_prev').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      setTimeout(() => {
        swiper2.slideTo(0, 0);
      }, 500);
    });
  });



  if (window.matchMedia("(min-width: 1024px)").matches) {
    document.querySelectorAll('.js_nav').forEach(nav => {
      nav.querySelectorAll('.nav__list-item').forEach(navItem => {
        const navItemText = navItem.innerText;
        navItem.insertAdjacentHTML('beforeend', `<div class="nav__list-placeholder">${navItemText}</div>`);
      });
      nav.classList.add('m-hasph');
    });

  }



  // SLIDEDOWN
  let slideHold = false;
  const slideUp = (target, duration = 500) => {
    // slideHold = true;
    target.classList.remove('m-active');
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      // slideHold = false;
    }, duration);
  }
  const slideDown = (target, duration = 500) => {
    target.classList.add('m-active');
    // slideHold = true;
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      // slideHold = false;
    }, duration);
  }
  const slideToggle = (target, duration = 500) => {
    return window.getComputedStyle(target).display === 'none'
      ? slideDown(target, duration)
      : slideUp(target, duration);
  }

  document.querySelectorAll('.js_slidedown_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!slideHold) {
        slideHold = true;
        let slideDuration = trigger.getAttribute('data-duration')
          ? trigger.getAttribute('data-duration')
          : 500;
        let thisTarget = trigger.getAttribute('data-target')
          ? document.querySelector(trigger.getAttribute('data-target'))
          : trigger.closest('.js_slidedown').querySelector('.js_slidedown_content');


        // if (!trigger.classList.contains('m-active')) {
        let thisDelay = trigger.getAttribute('data-delay') && window.matchMedia("(min-width: 1024px)").matches
          ? trigger.getAttribute('data-delay')
          : 0;
        setTimeout(() => {
          slideToggle(thisTarget, slideDuration);
        }, thisDelay);
        // } else {
        //   slideToggle(thisTarget, slideDuration);
        // }


        if (trigger.classList.contains('m-active')) {
          trigger.classList.remove('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.remove('m-active');
          }
        } else {





          trigger.classList.add('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.add('m-active');

            if (trigger.closest('.js_slidedown').classList.contains('js_slidedown_close')) {
              getSiblings(trigger.closest('.js_slidedown')).forEach(sdHolder => {
                if (sdHolder.classList.contains('m-active')) {
                  setTimeout(() => {
                    slideToggle(sdHolder.querySelector('.js_slidedown_content'), slideDuration);
                  }, thisDelay);
                  sdHolder.classList.remove('m-active');
                  sdHolder.querySelector('.js_slidedown_trigger').classList.remove('m-active');
                }
              });
            }
          }
        }

        setTimeout(() => {
          slideHold = false;
        }, (Number(slideDuration) + Number(thisDelay)));
      }
    });
  });
  // ========================

  // ACTIVE TOGGLE
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      let toggleTarget = ''
      if (trigger.getAttribute('data-target')) {
        toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
      } else if (trigger.getAttribute('href')) {
        toggleTarget = document.querySelector(trigger.getAttribute('href'))
      } else {
        toggleTarget = trigger.closest('.js_toggle');
      }
      trigger.classList.toggle('m-active');
      toggleTarget.classList.toggle('m-active');
    });
  });

  // ========================



});



// =================================================
// =================================================
// =================================================

